// Pure (no Office.js): shared by the executors and chat UI components.

export const CELL_EDIT_MODE_MESSAGE =
  "Excel is in cell-edit mode: the user must press Enter or Esc in the grid " +
  "before any tool can run. Ask them to do so, then retry.";

/** Whether an error message indicates Excel was blocked by cell-edit mode. */
export function isCellEditModeMessage(message: string | undefined): boolean {
  return message !== undefined && /cell-edit mode/i.test(message);
}
